module.exports = __webpack_public_path__ + "img/import-in-mass-simulation-active.09c01e8f.svg";